import React from "react";
import SignInButton from "./SignInButton";
import ScrollIndicator from "./ScrollIndicator";

const WelcomeSection = () => (
    <div className="flex flex-col flex-grow items-center justify-center text-center bg-red-600 w-full relative h-screen">
      <h1 className="sm:text-6xl md:text-6xl fownt-bold mb-4 text-white">Welcome to</h1>
      <img src="/logo.png" alt="Wish3s Logo" className="h-32 mb-4" />
      <SignInButton />
      <ScrollIndicator />

    </div>
);

export default WelcomeSection;
